import api from 'plugin/api';
import { API_URL } from 'types/const';

/**
 * 장기 IOMC 예측 리포트 등록
 * @param {Object} data 요청 데이터
 * @param {string} data.iomcYm 월
 * @param {string} data.buCode BU
 * @param {Object[]} data.rmcList 축종별 원재료비 실적 입력
 * @param {string} data.rmcList[].planYm 실적 월
 * @param {string} data.rmcList[].code 축종 ('RMC': Aver.RMC, '1F010': 양돈, '1F020': 낙농, '1F030': 비육, '1F040': 산란, '1F050': 육계, '1F070': 오리, '1F090': 반추소동물, '1F080': 양어)
 * @param {number} data.rmcList[].price 실적
 * @param {Object[]} data.iomcList 축종별 IOMC 입력
 * @param {string} data.iomcList[].planYm 실적 월
 * @param {string} data.iomcList[].code 축종 ('RMC': IOMC, '1F010': 양돈, '1F020': 낙농, '1F030': 비육, '1F040': 산란, '1F050': 육계, '1F070': 오리, '1F090': 반추소동물, '1F080': 양어)
 * @param {number} data.iomcList[].price 실적
 * @return {Object} 응답 데이터
 */
async function requestInsert(data) {
  return api.post(API_URL.sfms.report.iomc.insert, data);
}

/**
 * 장기 IOMC 예측 리포트 정보 조회
 * @param {Object} params 요청 데이터
 * @param {string} params.iomcYm 월
 * @param {string} params.buCode BU
 * @return {Object} 응답 데이터
 */
async function requestInform(params) {
  return api.get(API_URL.sfms.report.iomc.inform.default, { params });
}

/**
 * 장기 IOMC 예측 리포트 전체 결과 확인
 * @param {Object} data 요청 데이터
 * @param {string} data.iomcYm 월
 * @param {string} data.buCode BU
 * @param {Object[]} data.rmcList 축종별 원재료비 실적 입력
 * @param {string} data.rmcList[].planYm 실적 월
 * @param {string} data.rmcList[].code 축종 ('RMC': Aver.RMC, '1F010': 양돈, '1F020': 낙농, '1F030': 비육, '1F040': 산란, '1F050': 육계, '1F070': 오리, '1F090': 반추소동물, '1F080': 양어)
 * @param {number} data.rmcList[].price 실적
 * @param {Object[]} data.iomcList 축종별 IOMC 입력
 * @param {string} data.iomcList[].planYm 실적 월
 * @param {string} data.iomcList[].code 축종 ('RMC': IOMC, '1F010': 양돈, '1F020': 낙농, '1F030': 비육, '1F040': 산란, '1F050': 육계, '1F070': 오리, '1F090': 반추소동물, '1F080': 양어)
 * @param {number} data.iomcList[].price 실적
 * @return {Object} 응답 데이터
 */
async function requestCalculate(data) {
  return api.post(API_URL.sfms.report.iomc.calculate, data);
}

/**
 * 장기 IOMC 예측 리포트 최종 확인
 * @param {Object} data 요청 데이터
 * @param {string} data.iomcYm 월
 * @param {string} data.buCode BU
 * @return {Object} 응답 데이터
 */
async function requestConfirm(data) {
  return api.post(API_URL.sfms.report.iomc.confirm, data);
}

/**
 * 장기 IOMC 예측 리포트 취소
 * @param {Object} data 요청 데이터
 * @param {string} data.iomcYm 월
 * @param {string} data.buCode BU
 * @return {Object} 응답 데이터
 */
async function requestCancel(data) {
  return api.post(API_URL.sfms.report.iomc.cancel, data);
}

export {
  requestInsert,
  requestInform,
  requestCalculate,
  requestConfirm,
  requestCancel
};
